






























import { Mobile } from "@/mixins/mobile";
import { mixins } from "vue-class-component";
import { Component } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { StoreModule } from "@/store/types";
import { OrderGetters } from "@/store/modules/order/types";
import { Order } from "@/models/order/order";
import { EventBus } from "@/event-bus";
import SurchargeBanner from "@/components/footer/SurchargeBanner.vue";

@Component({ components: { SurchargeBanner } })
export default class CheckoutFooter extends mixins(Mobile) {
  @(namespace(StoreModule.Order).Getter(OrderGetters.GetOrder))
  storeOrder!: Order;

  get customerId(): string | undefined {
    return this.storeOrder.customer_id;
  }

  get hasItems(): boolean {
    return !!this.storeOrder.items?.length;
  }

  /**
   * A quote that has reached NetSuite must always sync back to it, and only
   * the submit flow does that. Saving here would persist to PSQL alone and
   * silently diverge from NetSuite, so the only way to persist a linked quote
   * is Review → Submit. Keyed off the NetSuite id rather than draft_status:
   * the link is what makes the quote authoritative in NS.
   */
  get isNetSuiteLinked(): boolean {
    return !!this.storeOrder.netsuite_id;
  }

  /** An existing PSQL draft is loaded (has an id), so Save Draft overwrites it
   * rather than creating a new one — reflect that in the button label. */
  get isExistingDraft(): boolean {
    return !!this.storeOrder.draft_id;
  }

  protected reviewQuote(): void {
    EventBus.$emit("reviewQuote");
  }

  /** FUPOF-191: CheckoutForm listens and persists its form data + the cart. */
  protected saveDraft(): void {
    EventBus.$emit("saveQuoteDraft");
  }
}
